<script>
	import { format_money_$_with_optional_cents } from 'shared/format_currency'

	export let subtotal
</script>

<div>{format_money_$_with_optional_cents(subtotal)}</div>

<style>
	div {
		color: #fff;
		font-size: 120%;
		line-height: 1;
	}
</style>
